import forEachSelector from './elements/forEachSelector';
import addStartupScript from './events/addStartupScript';

// Strikethrough content is in a <del> tag. This function adds a class to style the whole list item
function styleListItem(item) {
  if (item.querySelector('del')) {
    item.classList.add('list-item--strikethrough');
  }
}

export function setup() {
  forEachSelector('.list-item', styleListItem);
}

addStartupScript(setup);
